<ion-header class="remove-margin-from-safe-area ion-no-border">
  <ion-toolbar >
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-toolbar>
          <ion-buttons slot="end">
            <ion-button (click)="onCancelModal()" 
              ><ion-icon color="dark" name="close"></ion-icon
            ></ion-button>
          </ion-buttons>
        </ion-toolbar>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col style="text-align: center;">
          <h2 class="subheader-regular">{{ violation['Ticket']}}</h2>
        </ion-col>
      </ion-row>
    </ion-grid>
    
   
  </ion-toolbar>
</ion-header>


<ion-content>
  
  
    <ion-grid class="single-col-wider">
      <ion-row>
        <ion-col size="12">
            <form [formGroup]="appeal">
              <ion-grid>
                <ion-row>
                  <ion-col>
                    <ion-item fill="outline">
                      <ion-label position="floating">{{ ('keys.data.violations.reason_for_appeal' |
                        translate : {Default:'Reason for Appeal'} ) || 'Reason for Appeal' }}:</ion-label>
                      <ion-textarea
                        rows="5"
                        minlength="20"
                        formControlName="reason"
                        required
                        #reason
                      ></ion-textarea>
                    </ion-item>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>
                    <ng-container *ngIf="errors['error']">
                      <ion-text
                        rows="6"
                        color="danger"
                        *ngFor="let error of errors['error']['errors']['reason']"
                        >{{ error }}
                        <br />
                      </ion-text>
                    </ng-container>
                  </ion-col>
                </ion-row>
                
              </ion-grid>
              
              
              
            </form>
          
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-label class="ccard-text-regular">
            {{ ('keys.data.violations.appeal_error' |
            translate : {Default:'label: The reason must be at least 20 characters.'}) || 'Note: The reason must be at least 20 characters.' }}
            </ion-label>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12">
          <ion-button
            [disabled]="!appeal.valid"
            color="primary"
            expand="block"
            (click)="onSubmitAppeal()"
          >
          {{ ('keys.data.violations.submit_appeal' |
          translate : {Default:'Submit Appeal'}) || 'Submit Appeal' }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
</ion-content>
